import gql from 'graphql-tag';

export const searchCoverageHours = gql`
  query searchCoverageHours($channelId: UUID!, $pagination: PaginationInput!) {
    searchCoverageHours(channelId: $channelId, pagination: $pagination) {
      coverageHours {
        id
        routingId
        category
        issue
        teamId
        teamName
        daysOfWeek
        startMinute
        endMinute
        timezone
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
